import { subTopicImages } from "../servicesData";
import ServiceDetailPage from "../ServiceDetailPage";

const IPOReadinessAssessment = () => {
  const serviceData = {
    title: "IPO Readiness Assessment",
    heading: "IPO Readiness Assessment",
    image: subTopicImages["IPO Readiness Assessment"],
    intro:
      "A structured review to assess whether your organisation is prepared for public markets",
    description: [
      "Before initiating the listing process, it is critical for a company to understand whether it is genuinely ready — not only financially, but also from a governance, compliance, systems and control standpoint. An IPO changes how a business is viewed and monitored — by investors, regulators, analysts, and the public. Therefore, readiness must be carefully evaluated in advance.",
      "Our IPO Readiness Assessment is designed to help leadership teams clearly understand where the organisation currently stands — and what needs to be strengthened before the listing journey begins.",
    ],
    services: [
      {
        title: "IPO Readiness Review Areas",
        text: "We review the organisation across multiple dimensions, including:",
        list: [
          "quality and reliability of financial reporting",
          "accounting framework and Ind-AS readiness",
          "documentation and audit trail strength",
          "internal control environment & IFC",
          "governance structure & Board functioning",
          "statutory and regulatory compliance hygiene",
          "disclosures and investor-grade reporting standards",
          "risk management practices",
          "operational and process discipline",
        ],
        extraInfo:
          "We interact closely with management, finance, auditors and advisors to identify gaps, risks and improvement areas.",
      },
    ],
    benefitsIntro: "Deliverable — IPO Readiness Roadmap",
    benefits: [
      "existing strengths",
      "gaps versus listing requirements",
      "compliance & governance actions",
      "timelines & milestones",
      "responsibility mapping",
    ],
    research:
      "So promoters and Boards have full clarity on the journey ahead, even before committing to the IPO process.",
  };

  return (
    <ServiceDetailPage
      {...serviceData}
      overview={serviceData.description}
      services={serviceData.services}
      benefits={serviceData.benefits}
    />
  );
};

export default IPOReadinessAssessment;
